
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ContentLibraryFolderModel } from '../models/content-library-folder-model';
import { ContentLibraryFolderApiService } from '../../../api/contentLibrary/content-library-folder.api.service';
import { UpdateLibraryContentRequestApi } from '../../../api/contentLibrary/models/content-library-media.api.model';
import { AllResourceAbstractService } from '../../Basic/service/all-resource-abstract.service';
import { MultiBaseAbstractApi } from '../../../api/genericApi/multi-base-abstract.api';
import { ResourceAction } from '../../../Common/Basic/service/resource-abstract.service';
import { ContentLibraryFolderApi } from '../../../api/contentLibrary/models/content-library-folder.api.model';

@Injectable()
export class ContentLibraryFolderService
    extends AllResourceAbstractService<ContentLibraryFolderModel, ContentLibraryFolderApi, ContentLibraryFolderModel, ContentLibraryFolderApi> {

    constructor(
        protected contentLibraryFolderApiService: ContentLibraryFolderApiService,
    ) {
        super();
    }

    getApiService(): MultiBaseAbstractApi<ContentLibraryFolderApi, ContentLibraryFolderApi> {
        return this.contentLibraryFolderApiService;
    }

    constructListModel(listApiModel: ContentLibraryFolderModel): ContentLibraryFolderModel{
        return new ContentLibraryFolderModel(listApiModel);
    }

    constructResourceModel(apiModel: ContentLibraryFolderModel): ContentLibraryFolderModel {
        return new ContentLibraryFolderModel(apiModel);
    }

    messageCenter(actionResult: ResourceAction): void {
        return;
    }

    moveToLibrary(libraryId: string, mediaIds: string[]): Observable<number> {
        const request: UpdateLibraryContentRequestApi = {
            saveToLibraryContentIds: mediaIds,
            removeFromLibraryContentIds: mediaIds
        };
        return this.contentLibraryFolderApiService.updateLibraryContent(libraryId, request);
    }
}

